import React, {useState } from "react";
import PropTypes from "prop-types";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Routes from "../routes";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useDispatch } from 'react-redux'
import BreadCrumb from "../_partials/breadcrumb";
import BreadcrumbDispatch from '../_partials/breadcrumbDispatch';

const drawerWidth = "25%";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth})`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function MainLayout(props) {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List className="menuWrapper">
        <ListItem button className="menuItem active">
          <span className="menuItemSpan">
            <ListItemText className="menuTileWrapper">
              <span className="menuTile">Finding Rule</span>
              <span className="chevronRightIcon">
                <ChevronRightIcon style={{ fontSize: 28 }} />
              </span>
            </ListItemText>
            <ListItemText className="menuTileWrapper">
              <span className="menuTileSub">- No Finding Rule Selected -</span>
            </ListItemText>
          </span>
        </ListItem>
        <ListItem button className="menuItem">
          <span className="menuItemSpan">
            <ListItemText className="menuTileWrapper">
              <span className="menuTile">Finding Rule</span>
              <span className="chevronRightIcon">
                <ChevronRightIcon style={{ fontSize: 28 }} />
              </span>
            </ListItemText>
            <ListItemText className="menuTileWrapper">
              <span className="menuTileSub">- No Finding Rule Selected -</span>
            </ListItemText>
          </span>
        </ListItem>
        <ListItem button className="menuItem">
          <span className="menuItemSpan">
            <ListItemText className="menuTileWrapper">
              <span className="menuTile">Finding Rule</span>
              <span className="chevronRightIcon">
                <ChevronRightIcon style={{ fontSize: 28 }} />
              </span>
            </ListItemText>
            <ListItemText className="menuTileWrapper">
              <span className="menuTileSub">- No Finding Rule Selected -</span>
            </ListItemText>
          </span>
        </ListItem>
        <ListItem button className="menuItem">
          <span className="menuItemSpan">
            <ListItemText className="menuTileWrapper">
              <span className="menuTile">Finding Rule</span>
              <span className="chevronRightIcon">
                <ChevronRightIcon style={{ fontSize: 28 }} />
              </span>
            </ListItemText>
            <ListItemText className="menuTileWrapper">
              <span className="menuTileSub">- No Finding Rule Selected -</span>
            </ListItemText>
          </span>
        </ListItem>
        <ListItem button className="menuItem">
          <span className="menuItemSpan">
            <ListItemText className="menuTileWrapper">
              <span className="menuTile">Finding Rule</span>
              <span className="chevronRightIcon">
                <ChevronRightIcon style={{ fontSize: 28 }} />
              </span>
            </ListItemText>
            <ListItemText className="menuTileWrapper">
              <span className="menuTileSub">- No Finding Rule Selected -</span>
            </ListItemText>
          </span>
        </ListItem>
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <main className={classes.content} style={{position:"relative", paddingTop: 50}}>
        <div className={classes.toolbar} />
        <BreadcrumbDispatch />
        <BreadCrumb />
        <Routes />
      </main>
    </div>
  );
}

MainLayout.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default MainLayout;
